import Vue from 'vue'
import App from './App.vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n
import './assets/fonts/font.css'

import router from './router'
import store from './store'
import ToastComponent from './components/Toast.vue'

Vue.use(ElementUI, { locale })
Vue.config.productionTip = false

// ====== 创建 Toast 实例并挂载到 body ======
const ToastConstructor = Vue.extend(ToastComponent)
const toastInstance = new ToastConstructor()
toastInstance.$mount()
document.body.appendChild(toastInstance.$el)

// ====== 挂载全局 $toast 方法 ======
Vue.prototype.$toast = {
  success(message, duration = 2000) {
    toastInstance.show(message, 'success', duration)
  },
  error(message, duration = 2000) {
    toastInstance.show(message, 'error', duration)
  }
}
Vue.use(ElementUI, { locale })

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
}).$mount('#app')
